import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import ReactGoogleAutocomplete from 'react-google-autocomplete'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import MenuBarComponent from '../Components/MenuBarComponent';
import { Calendar } from 'primereact/calendar';
import { createEvent } from '@testing-library/dom';
import { createEventService, getEventByAccessKeyService, updateEventService } from '../Service/EventService';
import { toast } from 'react-toastify';
import { useContext, useEffect } from 'react';
import AuthContext from '../Contexts/AuthContext';
import moment from 'moment/moment';
        

function EventsForm({access_key, handleClose}) {
    
    const { t } = useTranslation('events');
    const {userAuth} = useContext(AuthContext)
    const googleMapsOptions = {
        types: ["address"],
        fields: ["address_components", "geometry", "place_id", "formatted_address"],
        strictBounds: false,
    }

    useEffect(()=>{
        getEvent()
    },[access_key])

    const getEvent = () => {
        access_key && getEventByAccessKeyService(access_key).then(res=>{
            if (res){
                setValue('access_key', res.access_key)
                setValue('name', res.title)
                setValue('description', res.description)
                setValue('address', res.address)
                setValue('lat', res.lat)
                setValue('lng', res.lng)
                setValue('date_start', new Date(res.date_start).toISOString().split('T')[0])
                setValue('date_end', new Date(res.date_end).toISOString().split('T')[0])
                setValue('time_start', res.time_start)
                setValue('time_end', res.time_end)
            }
        })
    }

    const {
            register,
            setValue,
            getValues,
            handleSubmit,
            control,
            formState: { errors },
          } = useForm({
            defaultValues: {
                email_visible: false,
                phone_visible: false,
            }
          });

    const onSubmit = (formData) => {
        if (getValues('access_key')){
            updateEventService(formData).then(res=>{
                if (res) {
                    toast.success(t('events_form_update_sucessfull'))
                    handleClose()
                }
            })
        } else {
            createEventService({...formData, created_by: userAuth?.user?.access_key}).then((res)=>{
                if (res) {
                    toast.success(t('events_form_create_sucessfull'))
                    handleClose()
                }
            })
        }
    }

    const handleAddress = (e) =>{
        const lat = e.geometry?.location?.lat();
        setValue('lat', lat);
        const lng = e.geometry?.location?.lng();
        setValue('lng', lng);
        setValue('address', e.formatted_address);
    }

    return (
        <div className='flex flex-column gap-4'>
            <div className='flex flex-column gap-2 p-4'>
                <form onSubmit={handleSubmit(onSubmit)} className='flex flex-column gap-2'>
                    <div className='flex flex-column gap-1'>
                        <label>{t('events_form_name')}<span className='form-validation-message'>*</span></label>
                        <InputText className='w-full' {...register('name', {
                            required: t('events_form_name_validation_message'),
                        })} />
                        {errors.name && <span className='form-validation-message'>{errors.name.message}</span>}
                    </div>
                    
                    <div className='flex flex-column gap-1'>
                        <label>{t('events_form_description')}<span className='form-validation-message'>*</span></label>
                        <InputTextarea rows={3} className='w-full' {...register('description', {
                            required: t('events_form_description_validation_message'),
                        })} />
                    </div>
                    
                    <div className='flex flex-column gap-1'>
                        <label>{t('events_form_address')}<span className='form-validation-message'>*</span></label>
                        <ReactGoogleAutocomplete defaultValue={getValues('address')} className='w-full p-inputtext p-component' apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} 
                        onPlaceSelected={handleAddress} options={googleMapsOptions} {...register('address', { 
                            required: t('events_form_address_validation_message'),
                        })} />
                        {errors.address && <span className='form-validation-message'>{errors.address.message}</span>}
                    </div>
                    
                    <div className='flex gap-2'>
                        <div className='flex flex-1 flex-column gap-1'>
                            <label>{t('events_form_date_start')}<span className='form-validation-message'>*</span></label>
                            <InputText type='date' className='w-full' {...register('date_start', {
                                required: t('events_form_date_start_validation_message'),
                            })} />
                            {errors.date_start && <span className='form-validation-message'>{errors.date_start.message}</span>}
                        </div>
                        <div className='flex flex-1 flex-column gap-1'>
                            <label>{t('events_form_time_start')}<span className='form-validation-message'>*</span></label>
                            <InputText type='time' className='w-full' {...register('time_start', {
                                required: t('events_form_time_start_validation_message'),
                            })} />
                            {errors.time_start && <span className='form-validation-message'>{errors.time_start.message}</span>}
                        </div>
                    </div>
                    
                    <div className='flex gap-2'>
                        <div className='flex flex-1 flex-column gap-1'>
                            <label>{t('events_form_date_end')}<span className='form-validation-message'>*</span></label>
                            <InputText type='date' className='w-full' {...register('date_end', {
                                required: t('events_form_date_end_validation_message'),
                            })} />
                            {errors.date_end && <span className='form-validation-message'>{errors.date_end.message}</span>}
                        </div>
                        <div className='flex flex-1 flex-column gap-1'>
                            <label>{t('events_form_time_end')}<span className='form-validation-message'>*</span></label>
                            <InputText type='time' timeOnly className='w-full' {...register('time_end', {
                                required: t('events_form_time_end_validation_message'),
                            })} />
                            {errors.time_end && <span className='form-validation-message'>{errors.time_end.message}</span>}
                        </div>
                    </div>
                    
                    <div className='flex gap-2 justify-content-center'>
                        <Button type='submit' label={t('events_form_save')} className='background-primary' />
                        <Button type='button' label={t('events_form_cancel')} className='background-secondary' onClick={()=>handleClose()} />
                    </div>
                </form>
            </div>
        </div>
    )
}

export default EventsForm